export function capitalize<T extends string>(value: T): Capitalize<T> {
  return (value ? value[0].toUpperCase() + value.slice(1) : value) as Capitalize<T>;
}
